import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function AiSettings() {
  return (
    <div className="ai-settings">
      <h5 className="mb-3">AI Settings</h5>

      <div className="section-border">

        <Row className="align-items-center">
          <Col md={3}>
            <label className="form-label">OpenAI API Key</label>
          </Col>

          <Col md={6}>
            <Form.Control placeholder="" />
          </Col>
        </Row>

        <hr />

        {/* ACTION BUTTONS */}
        <div className="text-end">
          <Button variant="light">Cancel</Button>
          <Button className="btn-orange ms-2">Save</Button>
        </div>

      </div>
      <style>
          {
               `
               /* SECTION BOX */
.section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 6px;
  background: #fff;
}

/* LABEL */
.ai-settings label {
  font-size: 14px;
  font-weight: 500;
}

/* INPUT */
.ai-settings .form-control {
  height: 40px;
  font-size: 14px;
}

/* BUTTON */
.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #e65c00;
}

/* MOBILE */
@media (max-width: 768px) {
  .ai-settings .row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 8px;
  }

  .ai-settings .col-md-3,
  .ai-settings .col-md-6 {
    width: 100%;
  }
}`
          }
      </style>
    </div>
  );
}